import { Operations, SeatTag } from "../../bookmydesk-api-sdk-typescript-axios";

export const kSeatTags: (SeatTag & Operations)[] = [
  {
    id: "06f375e2-0f85-4462-b440-b2a551f52a4d",
    label: "Dual Monitors",
    icon: null,
    _operations: {
      canDelete: false,
      cannotDeleteDescription: "Tag has linked places",
    },
  },
  {
    id: "02e0c680-d3b4-4d84-bb18-7a41b3c16bcf",
    label: "Privacy Panel",
    icon: null,
    _operations: {
      canDelete: false,
      cannotDeleteDescription: "Tag has linked places",
    },
  },
  {
    id: "02484105-c8c1-45bb-86fa-2ef5488e4db7",
    label: "Wide Seat",
    icon: null,
    _operations: {
      canDelete: true,
    },
  },
  {
    id: "0096ea26-a5b8-415d-bd85-9313e31de75d",
    label: "Whiteboard",
    icon: null,
    _operations: {
      canDelete: false,
      cannotDeleteDescription: "Tag has linked places",
    },
  },
  {
    id: "03cdc96e-8168-49db-8c44-1e6c6fb9e77c",
    label: "Standing Desk",
    icon: null,
    _operations: {
      canDelete: true,
    },
  },
];
